<template>
  <div class="detail_page">
    <div class="contentInfo">
      <div class="detailContianer">
        <!-- 基本信息 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/basicRed.png" alt="dark" />
              {{ $t("zlfk.jbxx") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions
              class="desc-container"
              :column="2"
              border
            >
              <!-- 车辆升级单号 -->
              <el-descriptions-item :label="$t('upgrade.upgradeNum')">{{
                upgradeInfo.upgradeOrderNum
              }}</el-descriptions-item>
              <!-- 主题 -->
              <el-descriptions-item :label="$t('upgrade.theme')">
                <div class="split-cell">
                  <div class="split-cell-original">{{ upgradeInfo.subject }}</div>
                  <div v-if="subjectTrans" class="split-cell-divider"></div>
                  <div v-if="subjectTrans" class="split-cell-trans">{{ subjectTrans }}</div>
                </div>
              </el-descriptions-item>
              <!-- OA报告名称 -->
<!--              <el-descriptions-item :label="$t('upgrade.oaReportName')">-->
<!--                <div class="split-cell">-->
<!--                  <div class="split-cell-original">{{ upgradeInfo.oaReportName }}</div>-->
<!--                  <div v-if="oaReportNameTrans" class="split-cell-divider"></div>-->
<!--                  <div v-if="oaReportNameTrans" class="split-cell-trans">{{ oaReportNameTrans }}</div>-->
<!--                </div>-->
<!--              </el-descriptions-item>-->
              <!-- 质量反馈单号 -->
              <el-descriptions-item :label="$t('upgrade.feedbackNum')">{{
                upgradeInfo.qualityFeedbackId
              }}</el-descriptions-item>
              <!-- 状态 -->
              <el-descriptions-item :label="$t('climant.status')">
                <span v-if="upgradeInfo.status == 0">{{
                  $t("upgrade.draft")
                }}</span>
                <span v-if="upgradeInfo.status == 1" class="successColor">{{
                  $t("upgrade.submitted")
                }}</span>
                <span v-if="upgradeInfo.status == 2" class="symbolColor">{{
                  $t("upgrade.obsolete")
                }}</span>
              </el-descriptions-item>
              <!-- 升级结束时间 -->
              <el-descriptions-item :label="$t('upgrade.endTime')">{{
                upgradeInfo.upgradeEndDate
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <div class="translate-row" v-if="upgradeInfo.subject || upgradeInfo.oaReportName">
              <el-select v-model="basicFrom" size="small" style="width: 100px;">
                <el-option v-for="item in langOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <i class="el-icon-sort" style="font-size: 18px; color: #999;"></i>
              <el-select v-model="basicTo" size="small" style="width: 100px;">
                <el-option v-for="item in langOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <el-button size="small" plain :loading="basicLoading" @click="handleBasicTranslate">
                {{ $t("home.translate") }}
              </el-button>
              <translate-btn
                ref="subjectBtn"
                :content="upgradeInfo.subject"
                field="subject"
                @getTranslateVal="getTranslateVal"
                v-show="false"
              />
              <translate-btn
                ref="oaReportNameBtn"
                :content="upgradeInfo.oaReportName"
                field="oaReportName"
                @getTranslateVal="getTranslateVal"
                v-show="false"
              />
            </div>
        </div>
        <!-- 升级方案 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/planIcon.png" alt="dark" />
              {{ $t("upgrade.plan") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions class="desc-container" :column="2" border>
              <!-- 升级原因 -->
              <el-descriptions-item :label="$t('upgrade.reason')">
                <div class="split-cell">
                  <div class="split-cell-original">{{ upgradeInfo.upgradeReason }}</div>
                  <div v-if="reasonTrans" class="split-cell-divider"></div>
                  <div v-if="reasonTrans" class="split-cell-trans">{{ reasonTrans }}</div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('zlfk.fj')">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="upgradeInfo.reasonFiles"
                ></file-upload-list
              ></el-descriptions-item>
              <!-- 升级措施 -->
              <el-descriptions-item :label="$t('upgrade.measure')">
                <div class="split-cell">
                  <div class="split-cell-original">{{ upgradeInfo.upgradeMeasure }}</div>
                  <div v-if="measureTrans" class="split-cell-divider"></div>
                  <div v-if="measureTrans" class="split-cell-trans">{{ measureTrans }}</div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('zlfk.fj')">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="upgradeInfo.measureFiles"
                ></file-upload-list>
              </el-descriptions-item>
              <!-- 索赔要求 -->
              <el-descriptions-item :label="$t('upgrade.claimRequest')">
                <div class="split-cell">
                  <div class="split-cell-original">{{ upgradeInfo.claimRequirement }}</div>
                  <div v-if="claimTrans" class="split-cell-divider"></div>
                  <div v-if="claimTrans" class="split-cell-trans">{{ claimTrans }}</div>
                </div>
              </el-descriptions-item>
              <el-descriptions-item :label="$t('zlfk.fj')">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="upgradeInfo.claimFiles"
                ></file-upload-list>
              </el-descriptions-item>
            </el-descriptions>
            <div class="translate-row">
              <el-select v-model="sharedFrom" size="small" style="width: 100px;">
                <el-option v-for="item in langOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <i class="el-icon-sort" style="font-size: 18px; color: #999;"></i>
              <el-select v-model="sharedTo" size="small" style="width: 100px;">
                <el-option v-for="item in langOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
              <el-button size="small" plain :loading="sharedLoading" @click="handleBatchTranslate">
                {{ $t("home.translate") }}
              </el-button>
              <translate-btn
                ref="reasonBtn"
                :content="upgradeInfo.upgradeReason"
                field="reason"
                @getTranslateVal="getTranslateVal"
                v-show="false"
              />
              <translate-btn
                ref="measureBtn"
                :content="upgradeInfo.upgradeMeasure"
                field="measure"
                @getTranslateVal="getTranslateVal"
                v-show="false"
              />
              <translate-btn
                ref="claimBtn"
                :content="upgradeInfo.claimRequirement"
                field="claim"
                @getTranslateVal="getTranslateVal"
                v-show="false"
              />
            </div>
          </div>
        </div>
        <!-- 车辆信息 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/carInfo.png" alt="" />
              {{ $t("zlfk.clxx") }}
            </div>
          </div>
          <div class="form-container">
            <div v-if="!this.isLookOperate" style="margin-bottom: 10px">
              <el-button
                class="primary-btn"
                type="primary"
                icon="el-icon-plus"
                @click="handleVIN"
                >{{ $t("upgrade.selectVIN") }}</el-button
              >
              <el-button
                class="primary-btn"
                @click="downModel"
                icon="el-icon-download"
                plain
              >
                {{ $t("zlfk.xzmb") }}
              </el-button>
              <el-button
                class="primary-btn"
                icon="el-icon-upload2"
                plain
                @click="batchUpload"
                >{{ $t("zlfk.pldr") }}</el-button
              >
            </div>
            <el-table
              ref="tableRef"
              stripe
              border
              :data="carList"
              highlight-current-row
              :max-height="420"
            >
              <!-- 序号 -->
              <el-table-column
                :label="$t('cart.xh')"
                width="60px"
                align="center"
                :render-header="$globalRenderHeader"
              >
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <!-- VIN -->
              <el-table-column
                label="VIN"
                min-width="180"
                align="center"
                prop="vin"
                :render-header="$globalRenderHeader"
              ></el-table-column>
              <!-- 品牌 -->
              <el-table-column
                :label="$t('home.brand')"
                min-width="130"
                prop="carBrand"
                :render-header="$globalRenderHeader"
              ></el-table-column>
              <!-- 车型 -->
              <el-table-column
                :label="$t('home.carType')"
                min-width="130"
                prop="carModel"
                :render-header="$globalRenderHeader"
              ></el-table-column>
              <!-- 订单号 -->
              <el-table-column
                :label="$t('cart.orderNumber')"
                min-width="130"
                align="center"
                prop="orderNum"
                :render-header="$globalRenderHeader"
              ></el-table-column>
              <!-- 国家 -->
              <!-- <el-table-column
                :label="$t('home.country')"
                min-width="130"
                align="center"
                prop="countryName"
                :render-header="$globalRenderHeader"
              ></el-table-column> -->
              <!-- 分配供应商名称 -->
              <!-- <el-table-column
                :label="$t('upgrade.customerName')"
                min-width="150"
                align="center"
                prop="distributeCustomerName"
                :render-header="$globalRenderHeader"
              ></el-table-column> -->
              <!-- 生产日期 -->
              <el-table-column
                :label="$t('seek.produceDate')"
                width="160"
                align="center"
                prop="productionDate"
                :render-header="$globalRenderHeader"
              ></el-table-column>
              <!-- 附件 -->
              <!-- <el-table-column
                :label="$t('zlfk.fj')"
                min-width="240px"
                :render-header="$globalRenderHeader"
              > -->
              <!-- <template slot-scope="scope">
                  <file-upload-list
                    ref="fileUploadList"
                    :fileList="carData.file"
                  ></file-upload-list>
                </template> -->
              <!-- </el-table-column> -->
              <!-- 操作 -->
              <el-table-column
                v-if="!this.isLookOperate"
                :label="$t('cart.operate')"
                align="center"
                width="90px"
                :render-header="$globalRenderHeader"
              >
                <template slot-scope="scope">
                  <!-- 删除 -->
                  <el-button type="text" @click="handleDelete(scope.row)">{{
                    $t("cart.delete")
                  }}</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 故障件信息 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/faultInfo.png" alt="dark" />
              {{ $t("upgrade.faultInfo") }}
            </div>
          </div>
          <div class="form-container">
            <!-- 主因故障件 -->
            <div>
              <p class="typeName">{{ $t("climant.mainFault") }}</p>
              <el-table
                ref="tableRef"
                stripe
                border
                :data="mainFaultList"
                highlight-current-row
                :max-height="420"
              >
                <el-table-column :label="$t('cart.xh')" width="60px" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column :label="$t('home.country')" min-width="100" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.countryName || '' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.hitchCode')" min-width="160" prop="faultPartNumber" align="center" :render-header="$globalRenderHeader" />
                <el-table-column :label="$t('climant.hitchName')" min-width="130" prop="faultPartName" :render-header="$globalRenderHeader" />
                <el-table-column :label="$t('climant.faultPrice')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.unitPrice != null ? Number(row.unitPrice).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.unitSource')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">
                    {{ row.sourceOfComponents === 0 ? $t('upgrade.partsSourceOverseas') : row.sourceOfComponents === 2 ? $t('upgrade.partsSourceSupplier') : row.sourceOfComponents === 1 ? $t('upgrade.partsSourceChargeable') : (row.sourceOfComponents != null ? row.sourceOfComponents : '-') }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('climant.changeNum')" width="100" prop="quantity" align="center" :render-header="$globalRenderHeader" />
                <el-table-column :label="$t('upgrade.repairPlan')" width="100" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">
                    {{ row.repairPlan === 0 ? $t('upgrade.repairTypeRepair') : row.repairPlan === 1 ? $t('upgrade.repairTypeReplace') : row.repairPlan === 2 ? $t('upgrade.repairTypeResend') : (row.repairPlan != null ? row.repairPlan : '-') }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('climant.manHour')" width="100" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.workingHours != null ? Number(row.workingHours).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.transportationCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.shippingFee != null ? Number(row.shippingFee).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.customs')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.tariff != null ? Number(row.tariff).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.travelCosts')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.travelPrice != null ? Number(row.travelPrice).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.otherCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.otherExpenses != null ? Number(row.otherExpenses).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.manageRate')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.managementFeeRate != null ? Number(row.managementFeeRate).toFixed(4) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('upgrade.laborCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.laborCost != null ? Number(row.laborCost).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.materialCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.materialCost != null ? Number(row.materialCost).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.faultTotalPrice')" width="130" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ calcFaultTotal(row) }}</template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 其他故障件 -->
            <div>
              <p class="typeName">{{ $t("climant.otherFault") }}</p>
              <el-table
                ref="tableRef"
                stripe
                border
                :data="otherFaultList"
                highlight-current-row
                :max-height="420"
              >
                <el-table-column :label="$t('cart.xh')" width="60px" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="scope">{{ scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column :label="$t('home.country')" min-width="100" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.countryName || '' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.hitchCode')" min-width="160" prop="faultPartNumber" align="center" :render-header="$globalRenderHeader" />
                <el-table-column :label="$t('climant.hitchName')" min-width="130" prop="faultPartName" :render-header="$globalRenderHeader" />
                <el-table-column :label="$t('climant.faultPrice')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.unitPrice != null ? Number(row.unitPrice).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.unitSource')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">
                    {{ row.sourceOfComponents === 0 ? $t('upgrade.partsSourceOverseas') : row.sourceOfComponents === 2 ? $t('upgrade.partsSourceSupplier') : row.sourceOfComponents === 1 ? $t('upgrade.partsSourceChargeable') : (row.sourceOfComponents != null ? row.sourceOfComponents : '-') }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('climant.changeNum')" width="100" prop="quantity" align="center" :render-header="$globalRenderHeader" />
                <el-table-column :label="$t('upgrade.repairPlan')" width="100" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">
                    {{ row.repairPlan === 0 ? $t('upgrade.repairTypeRepair') : row.repairPlan === 1 ? $t('upgrade.repairTypeReplace') : row.repairPlan === 2 ? $t('upgrade.repairTypeResend') : (row.repairPlan != null ? row.repairPlan : '-') }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('climant.manHour')" width="100" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.workingHours != null ? Number(row.workingHours).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.transportationCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.shippingFee != null ? Number(row.shippingFee).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.customs')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.tariff != null ? Number(row.tariff).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.travelCosts')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.travelPrice != null ? Number(row.travelPrice).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.otherCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.otherExpenses != null ? Number(row.otherExpenses).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.manageRate')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.managementFeeRate != null ? Number(row.managementFeeRate).toFixed(4) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('upgrade.laborCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.laborCost != null ? Number(row.laborCost).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.materialCost')" width="120" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ row.materialCost != null ? Number(row.materialCost).toFixed(2) : '-' }}</template>
                </el-table-column>
                <el-table-column :label="$t('climant.faultTotalPrice')" width="130" align="center" :render-header="$globalRenderHeader">
                  <template slot-scope="{ row }">{{ calcFaultTotal(row) }}</template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <!-- 费用信息 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/feeInfo.png" alt="dark" />
              {{ $t("upgrade.feeInfo") }}
            </div>
          </div>
          <div class="form-container">
            <el-table
              ref="tableRef"
              stripe
              border
              :data="costList"
              highlight-current-row
              :max-height="420"
            >
              <el-table-column :label="$t('cart.xh')" width="60px" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="scope">{{ scope.$index + 1 }}</template>
              </el-table-column>
              <el-table-column :label="$t('home.country')" min-width="100" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.countryName || '' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.manHour')" width="110" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.manHour != null ? Number(row.manHour).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.hourlyPrice')" width="120" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.hourlyRate != null ? Number(row.hourlyRate).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.manHourTotal')" width="130" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.totalCostOfWork != null ? Number(row.totalCostOfWork).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.materialTotal')" width="130" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.materialTotalCost != null ? Number(row.materialTotalCost).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.transportationCost')" width="120" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.freight != null ? Number(row.freight).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.customs')" width="120" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.tariffTotal != null ? Number(row.tariffTotal).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.otherCost')" width="120" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.otherTotalCost != null ? Number(row.otherTotalCost).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.travelCosts')" width="120" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.travelPriceTotal != null ? Number(row.travelPriceTotal).toFixed(2) : '-' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.climantTotal')" width="130" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ calcCostTotal(row) }}</template>
              </el-table-column>
              <el-table-column :label="$t('upgrade.otherInstruction')" min-width="140" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.otherInstruction || '' }}</template>
              </el-table-column>
              <el-table-column :label="$t('upgrade.otherInstructionTranslated')" min-width="160" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.otherInstructionZh || '' }}</template>
              </el-table-column>
              <el-table-column :label="$t('climant.currency')" width="100" align="center" :render-header="$globalRenderHeader">
                <template slot-scope="{ row }">{{ row.currency === 0 ? 'CNY' : row.currency === 1 ? 'USD' : '' }}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="flex_default_center" >
        <el-button class="primary-btn lang-but" v-if="!isLookOperate" @click="handleSubmitClaim">{{
          $t("seek.submit")
        }}</el-button>
        <el-button class="primary-btn lang-but" v-if="!isLookOperate" plain @click="handleCancel">
          {{$t("seek.cancel")}}
        </el-button>
        <el-button class="primary-btn lang-but" v-else @click="handleCancel">
          {{$t("zlfk.backto")}}
        </el-button>
      </div>
      <carInfoDialog
        ref="carInfoDialog"
        :upgradeOrderId="upgradeInfo.upgradeOrderId"
        @success="updateCarInfo"
      ></carInfoDialog>
      <upload-dialog ref="uploadDialog"></upload-dialog>
      <import-model-dialog
        :upgradeOrderId="upgradeInfo.upgradeOrderId"
        ref="importModelDialog"
        :uploadUrl="uploadUrl"
        @success="getUploadData"
      />
    </div>
  </div>
</template>
<script>
import {
  getUpgradeOrderDetail,
  downloadVinTemplate,
  submitUpgradeClaim,
} from "@/api/vehicleUpgrade.js";
import uploadDialog from "./uploadDialog.vue";
import carInfoDialog from "./carInfoDialog.vue";
import { uploadUrl } from "@/util/url";
import { getDownloadFiles } from "@/util/downFile";
import ImportModelDialog from "@/components/importModelDialog.vue";
import TranslateBtn from "@/components/translateBtn.vue";

export default {
  components: {
    carInfoDialog,
    uploadDialog,
    ImportModelDialog,
    TranslateBtn,
  },
  data() {
    return {
      pageName: {
        view: "upgrade.detailTitle",
        claim: "upgrade.initiateClaim",
      },
      upgradeOrderId: "",
      isLookOperate: false,
      problemData: {},
      qualityData: {},
      upgradeInfo: [],
      carList: [],
      mainFaultList: [],
      otherFaultList: [],
      costList: [],
      uploadUrl: uploadUrl + "/customer/vehicle/upgrade/order/vinImport",
      subjectTrans: "",
      oaReportNameTrans: "",
      basicFrom: "zh-CHS",
      basicTo: "en",
      basicLoading: false,
      reasonTrans: "",
      measureTrans: "",
      claimTrans: "",
      sharedFrom: "zh-CHS",
      sharedTo: "en",
      sharedLoading: false,
      langOptions: [
        { value: "zh-CHS", label: "中文" },
        { value: "en", label: "English" },
        { value: "ko", label: "한국어" },
        { value: "fa", label: "فارسی" },
        { value: "ru", label: "русск" },
        { value: "es", label: "español" },
        { value: "tr", label: "Turkish" },
        { value: "it", label: "italiano" },
        { value: "vi", label: "Việt nam" },
      ],
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getInitializeInfo();
    },
  },
  created() {
    this.getInitializeInfo();
  },
  methods: {
    // 获取升级单详情
    async getUpgradeInfo() {
      const res = await getUpgradeOrderDetail({
        data: {
          upgradeOrderId: this.upgradeOrderId,
        },
      });
      this.upgradeInfo = res.data;
      var allVins = res.data.vinList || [];
      // claim 模式下只展示待索赔的 VIN（status 为空或已驳回 2）
      if (this.$route.query.status === 'claim') {
        this.carList = allVins.filter(v => v.status === null || v.status === undefined || v.status === 2);
      } else {
        this.carList = allVins;
      }
      // faultType 0: 其他故障件; 1:主因故障件;
      var faultList = res.data.faultPartsList;
      // 主因故障件
      this.mainFaultList = faultList.filter((item) => item.faultType === 1);
      // 其他故障件
      this.otherFaultList = faultList.filter((item) => item.faultType === 0);
      this.costList = res.data.costList;
    },
    // 取消
    handleCancel() {
      this.$router.push({ path: "/qualityNew/qualityUpgrade" });
    },
    // 发起索赔提交
    handleSubmitClaim() {
      if (this.carList.length === 0) {
        this.$DonMessage.warning("VIN 列表不能为空");
        return;
      }
      this.$confirm("确认提交索赔？提交后将进入审核流程。", "提示", { type: "warning" })
        .then(() => {
          submitUpgradeClaim({
            data: {
              upgradeOrderId: this.upgradeOrderId,
              vinList: this.carList.map((v) => ({
                id: v.id || null,
                vin: v.vin,
                carBrand: v.carBrand,
                carModel: v.carModel,
                orderNum: v.orderNum,
                completeStatus: v.completeStatus,
                countryDataId: v.countryDataId,
                countryName: v.countryName,
                productionDate: v.productionDate,
              })),
            },
          }).then((res) => {
            if (res && (res.status === "0" || res.status === 0)) {
              this.$DonMessage.success("索赔提交成功");
              this.$router.push({ path: "/qualityNew/qualityUpgrade" });
            } else {
              this.$DonMessage.error((res && res.message) || "提交失败");
            }
          });
        })
        .catch(() => {});
    },
    n(v) {
      const num = Number(v);
      return isNaN(num) ? 0 : num;
    },
    calcFaultTotal(row) {
      const total =
        this.n(row.laborCost) +
        this.n(row.materialCost) +
        this.n(row.shippingFee) +
        this.n(row.tariff) +
        this.n(row.travelPrice) +
        this.n(row.otherExpenses);
      return total.toFixed(2);
    },
    calcCostTotal(row) {
      const total =
        this.n(row.totalCostOfWork) +
        this.n(row.materialTotalCost) +
        this.n(row.freight) +
        this.n(row.tariffTotal) +
        this.n(row.otherTotalCost) +
        this.n(row.travelPriceTotal);
      return total.toFixed(2);
    },
    // 选择VIN
    handleVIN() {
      this.$refs.carInfoDialog.init(this.carList);
    },
    // 更新车辆信息
    updateCarInfo(list) {
      list.forEach((item) => {
        if (!this.carList.some((itm) => itm.vin === item.vin)) {
          this.carList.push(item);
        }
      });
    },
    // 删除
    handleDelete({ index, id }) {
      this.carList.splice(index, 1);
    },
    // 下载模板
    downModel() {
      downloadVinTemplate().then((res) => {
        getDownloadFiles(res, "车辆升级VIN导入模板.xlsx");
      });
    },
    // 批量上传
    batchUpload() {
      this.$refs.importModelDialog.init(this.$t("zlfk.pldr"));
    },
    getUploadData(data) {
      var matchedList = data.matchedList;
      var notFoundVins = data.notFoundVins;
      const existingVins = new Set(this.carList.map((item) => item.vin));
      let duplicates = [];
      let repeatText = "";
      let notFoundText = "";
      if (matchedList.length > 0) {
        console.log(matchedList, existingVins);
        duplicates = matchedList
          .filter((item) => existingVins.has(item.vin))
          .map((item) => item.vin);
        if (duplicates.length > 0) {
          repeatText = `<div class="vin-repear">
            <p>${this.$t("upgrade.vinRepear")}:</p>
            <div>${duplicates.map((vin) => `<span>${vin}</span>`).join("")}</div>
          </div>`;
        }
        matchedList.forEach((item) => {
          if (!existingVins.has(item.vin)) {
            this.carList.push(item);
            existingVins.add(item.vin); // 更新 Set
          }
        });

      }

      if (notFoundVins.length > 0) {
        notFoundText = `
          <div class="vin-not-found">
            <p>${this.$t("upgrade.vinNotFound")}:</p>
            <div>${notFoundVins.map((vin) => `<span>${vin}</span>`).join("")}</div>
          </div>
        `;
      }
      const message = `
        ${repeatText || ""}
        ${notFoundText || ""}
      `;
      if (message.trim()) {
        this.$confirm(message, this.$t("request.tips"), {
          confirmButtonText: this.$t("home.confirm"),
          cancelButtonText: this.$t("seek.cancel"),
          type: "warning",
          dangerouslyUseHTMLString: true, // 允许 HTML（需确保内容安全）
        })
          .then(() => {

          })
          .catch(() => {

        });
      }

    },
    // 内容高度
    heightSize() {
      setTimeout(() => {
        var allHeight = $(".contentInfo").height();
        var butHeight = $(".flex_default_center").outerHeight(true);
        var val = allHeight - butHeight;
        $(".detailContianer").css("height", val);
      });
    },
    sizeArea() {
      var _this = this;
      _this.heightSize();
      window.addEventListener("resize", () => {
        _this.heightSize();
      });
    },
    getInitializeInfo() {
      this.$route.meta.title = this.pageName[this.$route.query.status];
      this.upgradeOrderId = this.$route.query.upgradeOrderId;
      this.isLookOperate = this.$route.query.status === "view" ? true : false;
      this.getUpgradeInfo();
      this.sizeArea();
    },
    getTranslateVal(field, value) {
      this[field + "Trans"] = value;
    },
    async handleBasicTranslate() {
      const refs = ["subjectBtn", "oaReportNameBtn"];
      this.basicLoading = true;
      for (const name of refs) {
        const btn = this.$refs[name];
        if (btn && btn.content) {
          btn.from = this.basicFrom;
          btn.to = this.basicTo;
          await btn.translateTextCus();
          await new Promise((r) => setTimeout(r, 500));
        }
      }
      this.basicLoading = false;
    },
    async handleBatchTranslate() {
      const refs = ["reasonBtn", "measureBtn", "claimBtn"];
      this.sharedLoading = true;
      for (const name of refs) {
        const btn = this.$refs[name];
        if (btn && btn.content) {
          btn.from = this.sharedFrom;
          btn.to = this.sharedTo;
          await btn.translateTextCus();
          await new Promise((r) => setTimeout(r, 500));
        }
      }
      this.sharedLoading = false;
    },
  },
};
</script>
<style scoped>
.contentInfo {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.detailContianer {
  flex: 1;
  overflow: auto;
}
.form-container .el-table {
  margin: 5px 0 15px;
}
.typeName {
  font-size: 15px;
  font-weight: bold;
  margin: 12px 0;
}
.translate-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
}
.split-cell {
  display: flex;
  min-height: 28px;
}
.flex_default_center {
  flex-shrink: 0;
}
.split-cell-original {
  flex: 1;
  word-break: break-all;
}
.split-cell-divider {
  width: 1px;
  background: #dcdfe6;
  margin: 0 10px;
}
.split-cell-trans {
  flex: 1;
  word-break: break-all;
  color: #409eff;
}
</style>
<style>
 .vin-repear,
.vin-not-found {
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
.vin-repear > p,
.vin-not-found > p {
  font-size: 15px;
  font-weight: bold;
}
.vin-repear > div,
.vin-not-found > div  {
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
.vin-repear div span,
.vin-not-found div span {
  margin-right: 5px;
  margin-bottom: 3px;
  padding: 2px 5px;
  font-size: 14px;
  background-color: var(--hover-color);
}
</style>
